import { DEFAULT_API_CONFIG } from './apiConfig';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/grid-filters`;

export const getGridFilters = async gridNameId => {
  const response = await fetch(`${baseRoute}?gridNameId=${gridNameId}`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const saveGridFilter = async ({ id, gridNameLookupId, filterName, filterDescription, filterValue, sortValue }) => {
  const response = await fetch(baseRoute, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ id, gridNameLookupId, filterName, filterDescription, filterValue, sortValue }),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const reorderGridFilters = async orderedIds => {
  const response = await fetch(`${baseRoute}/reorder`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ orderedIds }),
  });
  return response.ok ? Promise.resolve() : Promise.reject(response);
};

export const toggleGridFilterActive = async id => {
  const response = await fetch(`${baseRoute}/${id}/toggle-active`, {
    method: 'PATCH',
    headers: getHeaders(),
  });
  return response.ok ? Promise.resolve() : Promise.reject(response);
};

export const deleteGridFilter = async id => {
  const response = await fetch(`${baseRoute}/${id}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  return response.ok ? Promise.resolve() : Promise.reject(response);
};

export const getMyUnderwriterId = async () => {
  const response = await fetch(`${baseRoute}/my-underwriter-id`, {
    method: 'GET',
    headers: getHeaders(),
  });
  return response.ok ? await response.json() : Promise.reject(response);
};
